import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavigationModule } from '..//navigation/navigation.module';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

import { HeadernavComponent } from './headernav.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        NavigationModule,
        PerfectScrollbarModule,
    ],
    declarations: [HeadernavComponent],
    exports: [HeadernavComponent]
})
export class HeadernavModule { }
